import "bootstrap/dist/css/bootstrap.min.css";

import React, { useEffect, useState } from "react";
import { PaginationControl } from "react-bootstrap-pagination-control";

const Pagination = ({ onChange, page, total, per_page  }) => {
  const [mpage, setPage] = useState(1);


  useEffect(() => {
    setPage(page)
  },[page])

  return (
    <PaginationControl
      page={mpage}
      between={4}
      total={total}
      limit={per_page}
      next={true}
      changePage={(page) => {
        onChange(page);
      }}
      ellipsis={1}
    />
  );
};

export default Pagination;
